import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Usuario } from '../models/usuario';
import { retry} from 'rxjs/operators';

// const AUTH_API = environment.apiUrl + '/auth/';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }

  login(username: string, password: string): Observable<Usuario> {
    return this.http.post<Usuario>(environment.apiUrl + '/login', {
      username,
      password
    }, httpOptions).pipe(
      retry(1)
    );
  }

  register(username: string, email: string, password: string): Observable<any> {
    return this.http.post(environment.apiUrl + '/logout', {
      username,
      email,
      password
    }, httpOptions);
  }
}